import React from "react"

const VARIANT_MAP = {
    p: "text-base mb-2",
    lead: "text-lg mb-3 text-white",
    lead_black: "text-lg mb-3 text-black",
    lead_black_bold: "text-lg mb-3 text-black font-bold",
    bold: "text-base mb-2 font-bold",
    small: "text-sm mb-1 text-gray-500",
    small_white: "text-sm mb-1 text-white",
    small_white_bold: "text-sm mb-1 text-white font-bold",
    xs: "text-xs sm:text-sm text-black",
    xs_gray: "text-xs mb-1 text-gray-600",
}

export default function Paragraph({ variant = "p", children }) {
    const Tag = variant in VARIANT_MAP ? "p" : "p"
    const className = VARIANT_MAP[variant] || VARIANT_MAP.p

    return (
        <Tag className={className}>
            {children}
        </Tag>
    )
}
